import { configureStore } from '@reduxjs/toolkit'
import { AppState } from './app/types'
import { rootReducer } from './rootReducer'

export interface State {
    app: AppState,
}

export const store = configureStore({ reducer: rootReducer })